import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Home.css';

function Home() {
  const { user } = useAuth();

  if (user) {
    return <Navigate to="/browse" replace />;
  }

  return (
    <div className="home-container">
      <div className="hero-section">
        <h1>Welcome to SponsorBoat</h1>
        <p>Your platform for connecting YouTube channels and blogs with sponsorship opportunities</p>
        <div className="cta-buttons">
          <a href="/submission" className="cta-button primary">Submit Your Content</a>
          <a href="/youtube" className="cta-button secondary">Browse YouTube Channels</a>
        </div>
      </div>

      <div className="features-section">
        <h2>How It Works</h2>
        <div className="features-grid">
          <div className="feature-card">
            <h3>📺 YouTube Channels</h3>
            <p>Browse and discover YouTube channels by subscriber count. Connect with content creators.</p>
          </div>
          <div className="feature-card">
            <h3>📝 Blog Posts</h3>
            <p>Explore blog posts filtered by monthly views. Find high-traffic blogs for your brand.</p>
          </div>
          <div className="feature-card">
            <h3>✅ Easy Submission</h3>
            <p>Submit your channel or blog in minutes. Get featured on our platform instantly.</p>
          </div>
        </div>
      </div>

      <div className="stats-section">
        <h2>Our Platform</h2>
        <div className="stats-grid">
          <div className="stat-card">
            <h3>YouTube</h3>
            <p>Browse verified channels</p>
          </div>
          <div className="stat-card">
            <h3>Blog Posts</h3>
            <p>Discover quality content</p>
          </div>
          <div className="stat-card">
            <h3>Free</h3>
            <p>Submit your content</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
